export const mockCheckoutContractItemDetails = {
  brand: 'Hotpoint',
  description: 'Washing machine',
  itemId: '12443',
};
